<template>
  <div class="footer">
    <img src="../assets/img/footer.png" />
    <div class="footer-bottom">
      <div class="footer-bottom-sentence">
        {{
          "※端末の性能や仕様、端末固有のアプリ仕様状況などにより、正常に動作しない場合があります。"
        }}
      </div>
      <div class="footer-bottom-line">
        <a href="https://www.cosmo-japan.net/" target="blank">{{
          "©︎ 2024 Cosmo Japan Co., Ltd. All Rights Reserved."
        }}</a>
      </div>
    </div>
  </div>
</template>

<script></script>

<style>
.footer {
  width: 100%;
}

img {
  width: 100%;
}

.footer-bottom {
  padding: 20px 10px;
  line-height: 2em;
  text-align: center;
}
.footer-sentence {
  text-align: center;
  white-space: pre-wrap;
  color: #707070;
  margin-bottom: 10px;
}
</style>
